import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';

import { Icons } from '../../../Icons';
import { getColor } from '../../../styles/themeGetters';
import { Tooltip } from '../../../Tooltip';
import messages from './messages';

type ClearButtonProps = {
  $align?: string;
};

const ClearButton = styled.button<ClearButtonProps>`
  border: none;
  border-radius: 4px;
  background: none;
  padding: 0;
  align-self: ${props => props.$align || 'baseline'};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};

  &:hover {
    background-color: ${getColor('grey-light-50')};
  }
`;

type Props = {
  onClick: () => void;
  disabled?: boolean;
  align?: string;
};

const InputFieldClearButton = ({ onClick, disabled, align }: Props) => {
  const { formatMessage } = useIntl();
  const label = formatMessage(messages.clear);
  return (
    <Tooltip tooltipContent={label}>
      <ClearButton
        onClick={onClick}
        disabled={disabled}
        type="button"
        $align={align}
        aria-label={label}
      >
        <Icons.Close />
      </ClearButton>
    </Tooltip>
  );
};

export { InputFieldClearButton };
